export default [
  { text: 'Цикл', value: 'cycle_id', width: '70px' },
  { text: 'Получено', value: 'received_at', width: '150px' },
  { text: 'Поставщик', value: 'supplier_name', width: '190px' },
  { text: 'РЦ', value: 'werk_code', width: '70px' },
  { text: 'Название РЦ', value: 'werk_name', width: '220px' },
  { text: 'Дата', value: 'return_date', width: '105px', sortable: true, sortDirection: 'desc' },
  { text: 'Ворота', value: 'gate', width: '80px' },
  { text: 'Время', value: 'slot_time', width: '120px' },
  { text: 'Кол-во X5', value: 'quantity', width: '100px' },
  { text: 'Остаток', value: 'balance_value', width: '90px' },
  { text: 'Мин/макс РЦ', value: 'werk_limits', width: '110px' },
  { text: 'Мин/макс региона', value: 'region_limits', width: '130px' },
  { text: 'Статус', value: 'result_status', width: '170px' },
  { text: 'Причина', value: 'reason', width: '260px' }
]
